import { getDifferenceInDays } from './getDifferenceInDays';

export function validateDaysLimit(firstDate, secondDate, limit) {
  return getDifferenceInDays(new Date(firstDate), secondDate) <= limit;
}
